import { AxiosInstance } from 'axios';

import { axios } from '../../../../api/axios-instance';
import { userCompetitionEndpoints } from '../../../../constants';
import {
  PaginatedUserCompetitions,
  UpdateUserCompetition,
  UpdateUserCompetitionResult,
  UpdateUserCompetitionStep,
} from '../../../user/schemas/user-competition.schema';
import { UserCompetitions } from '../../entities/user-competitions';

class UserCompetitionApi {
  #requestInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.#requestInstance = axiosInstance;
  }

  create = (competition: UserCompetitions) => {
    return this.#requestInstance
      .post(userCompetitionEndpoints.userCompetition, { ...competition, createdAt: new Date() })
      .then(({ data }) => data);
  };

  deleteUserCompetition = async (id: number): Promise<void> => {
    return this.#requestInstance.delete(
      userCompetitionEndpoints.deleteUpdateUserCompetitionById(id)
    );
  };

  getUserCompetitions = async (competition: {
    id: number;
    order?: string;
    limit?: number;
    offset?: number;
  }): Promise<PaginatedUserCompetitions> => {
    const { order, offset, limit } = competition;
    return this.#requestInstance.get(
      userCompetitionEndpoints.getUserCompetitionById(competition.id),
      { params: { sortBy: order, limit, offset } }
    );
  };

  updateUserCompetition = async (competitionDto: UpdateUserCompetition): Promise<void> => {
    return this.#requestInstance.patch(
      userCompetitionEndpoints.deleteUpdateUserCompetitionById(competitionDto.id),
      {
        name: competitionDto.name,
        description: competitionDto.description,
        bet: competitionDto.bet,
        participantId: competitionDto.participantId,
      }
    );
  };

  updateUserCompetitionStepById = async (
    competitionDto: UpdateUserCompetitionStep
  ): Promise<void> => {
    return this.#requestInstance.patch(
      userCompetitionEndpoints.updateUserCompetitionStepById(competitionDto.id),
      {
        step: competitionDto.competitionStep,
        participantId: competitionDto.participant,
      }
    );
  };

  updateUserCompetitionResults = async (
    competitionDto: UpdateUserCompetitionResult
  ): Promise<void> => {
    return this.#requestInstance.patch(
      userCompetitionEndpoints.updateUserCompetitionResultById(competitionDto.id),
      {
        initiatorId: competitionDto.initiator,
        winnerId: competitionDto.winnerId,
        status: competitionDto.competitionStep,
      }
    );
  };
}

export const userCompetitionsApi = new UserCompetitionApi(axios);
